import adComputed from "@/mixins/adComputed";
import {mapMutations, mapState} from "vuex";

export default {
    computed: {
        ...mapState({
            curBanner: (state) => state.dealers.curBanner
        })
    },
    mixins: [adComputed],
    methods: {
        ...mapMutations('dealers', {
            setCurBanner: 'setCurBanner',
            setResCars: 'setResCars'
        }),
        insertSliderAd() {
            const rowCount = this.getCarPerRow - 1;
            const addProp = {isSlider: true, ad: true};
            if (this.d.cars && this.d.cars.length && this.allAd && this.allAd.length > 0) {
                this.d.cars[1].cars.splice(rowCount, 0, {...addProp, ...this.allAd[0], adData: this.allAd[0]});

                const secondAd = this.allAd.length > 1 ? this.allAd[1] : this.allAd[0];
                this.d.cars[3].cars.splice(rowCount, 0, {...addProp, ...secondAd, adData: this.allAd[1]});
            }
        },
        insertAd() {
            if (!this.allAd || this.allAd.length === 0) {
                return;
            }

            if (this.$device.tablet()) {
                this.insertSliderAd();
            }

            if (this.$device.desktop()) {
                this.insertSliderAd();
            }
            let insertIndex = [];

            let carsByFilter = this.d.res.filter(e => !e.ad);

            let firstPerCars = parseInt(this.getCarPerRow + ((this.getCarPerRow / 2) - 1));
            const perCars = parseInt((this.getCarPerRow * 5) + ((this.getCarPerRow / 2) - (this.getCarPerRow > 3 ? 1 : 0)));//this.ad.search_results_per_car || 20;
            const maxItems = this.allAd.length;

            carsByFilter.map((e, i) => {
                if (insertIndex.length === 0 && i > 0 && i % firstPerCars === 0) {
                    insertIndex.push(i);
                } else if (i > 0 && (i - firstPerCars) % perCars === 0) {
                    insertIndex.push(i);
                }
                return e;
            });

            if (carsByFilter.length > 0 && carsByFilter.length <= firstPerCars) {
                insertIndex.push(carsByFilter.length);
            }

            let curItem = this.curBanner;
            let curAd = null;
            insertIndex.map((e, i) => {
                if (curItem > maxItems) {
                    curItem = 0;
                }

                curAd = this.allAd[curItem];
                //this.setCurBanner(curItem);
                //carsByFilter.splice(e, 0, {ad: true, ...curAd, adData: curAd});
                carsByFilter.splice(e, 0, {ad: true, ...{empty: true}});


                if (i % maxItems === 0 && curItem != 0) {
                    curItem = 0;
                } else {
                    curItem++;
                }
            });
            this.d.res = carsByFilter;
        }
    },
}
